export const mapDeepErrors = errors =>
  Object.keys(errors).map(key => ({
    label: key,
    value:
      Array.isArray(errors[key]) &&
      !errors[key].every(error => typeof error === 'string')
        ? mapDeepErrors(errors[key])
        : errors[key]
  }))

export const mapError = ({ value, label }, index) => {
  if (typeof value === 'string') {
    return (
      <li key={index}>
        {label !== 'nonFieldErrors' ? label : 'error'}: {value}
      </li>
    )
  }

  if (Array.isArray(value)) {
    const stringsValues = value.filter(
      (err, i) => typeof err === 'string' || typeof err === 'string'
    )

    return (
      <ul key={index}>
        {label && label !== 'nonFieldErrors' && (
          <li>
            <u> {label}: </u>
          </li>
        )}

        {value.map(
          (err, i) =>
            (typeof err !== 'string' || typeof err !== 'string') &&
            mapError({ value: err })
        )}

        <ul>
          {stringsValues.map((err, i) => (
            <li key={i}>{err}</li>
          ))}
        </ul>
      </ul>
    )
  }

  if (typeof value === 'object') {
    return (
      <ul key={index}>
        {label && label !== 'nonFieldErrors' && (
          <li>
            <u>{label}</u>
          </li>
        )}
        {Object.keys(value).map(key =>
          mapError({ label: key, value: value[key] })
        )}
      </ul>
    )
  }
}

/**
 * @function _errorsToPlanList
 * @param {*} errors | {nonFieldErrors: [], errorCodes: []} | {errors: [{message: 'error'}]} | {errors: ['error1', 'error2']}
 * @returns {Array[str]} errorsList
 */
function _errorsToPlanList(errors, maxTreeDepth = 0) {
  // Note: I'm worried about the performance of this function.
  // It will deal with any kind of error structure and it's recursive.
  // I'm setting a limit to the depth of the tree to avoid infinite loops.

  const LIMIT_DEPTH = 10
  if (maxTreeDepth >= LIMIT_DEPTH) {
    return []
  }

  const clean = errors => [...new Set(errors.filter(Boolean))]

  if (!errors) {
    return []
  }

  if (typeof errors === 'string') {
    return clean([errors])
  }

  if (Array.isArray(errors)) {
    return clean(
      errors.map(errors => _errorsToPlanList(errors, maxTreeDepth + 1)),
    )
  }

  if (typeof errors === 'object' && errors.nonFieldErrors) {
    return clean(
      errors.nonFieldErrors.map(errors =>
        _errorsToPlanList(errors, maxTreeDepth + 1),
      ),
    )
  }

  if (typeof errors === 'object' && errors.errors) {
    return clean(
      errors.errors.map(errors => _errorsToPlanList(errors, maxTreeDepth + 1)),
    )
  }

  if (typeof errors === 'object') {
    return clean(
      Object.keys(errors).map(key =>
        _errorsToPlanList(errors[key], maxTreeDepth + 1),
      ),
    )
  }

  return []
}

export function errorsToPlanList(errors) {
  try {
    return _errorsToPlanList(errors)
  } catch (error) {
    console.error('Error while parsing errors:', error)
    return [
      'Ocurrió un error inesperado. Por favor contacta a tu equipo de soporte.',
    ]
  }
}
